var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHifzESurah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.394,
    height: 221.413,
    viewBox: "0 0 272.394 221.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7952",
    "data-name": "Group 7952",
    transform: "translate(-159.233 -165.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39340",
    "data-name": "Path 39340",
    d: "M205.115,185.119,168.1,214.944v12.381l21.474-17.89,18.172,20.013L168.1,265.55v16.484l86.366-81.608-49.348-15.308",
    transform: "translate(40.966 101.64)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39341",
    "data-name": "Path 39341",
    d: "M295.43,302.026,161.08,260.461,187.7,167.708l107.732,39.72Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39342",
    "data-name": "Path 39342",
    d: "M230.076,185.119l37.018,29.825v12.381l-20.549-17.293L229.2,228.663l37.9,36.887v16.484l-86.366-81.608,49.348-15.308",
    transform: "translate(114.702 101.64)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39343",
    "data-name": "Path 39343",
    d: "M180.728,302.026l134.35-41.565L288.46,167.708l-107.732,39.72Z",
    transform: "translate(114.702 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHifzESurah);
export default __webpack_public_path__ + "static/media/Hifz_e_Surah.cac26fd6331256ad0d41fc0a5f022210.svg";
export { ForwardRef as ReactComponent };